module.exports = __webpack_public_path__ + "img/img27.4a84aae1.png";